import type { PropsWithChildren } from "react";
import { createPortal } from "react-dom";

import { useEmojiPickerContext } from "./EmojiPickerContext";

interface EmojiPickerWrapperProps {
  open?: boolean;
  portalTo?: any;
  shouldEmojiPickerRenderAsPortal?: boolean;
}

export const EmojiPickerWrapper = ({
  shouldEmojiPickerRenderAsPortal,
  children,
  open,
  portalTo,
}: PropsWithChildren<EmojiPickerWrapperProps>) => {
  const { emojiPickerPopoverRef } = useEmojiPickerContext();
  const className = "relative z-[9999]";

  if (shouldEmojiPickerRenderAsPortal) {
    return (
      <>
        {open &&
          createPortal(
            <div ref={emojiPickerPopoverRef} className={className}>
              {children}
            </div>,
            portalTo || document.body,
          )}
      </>
    );
  }

  return (
    <div ref={emojiPickerPopoverRef} className={className}>
      {children}
    </div>
  );
};
